<template>
    <div v-if="flows.hasData.value">
        <flex-container justify-content="space-between" style="margin-bottom: 1rem">
            <text-heading>
                <flex-container
                    size="full"
                    no-wrap
                    align-items="center"
                    gap="sm"
                >
                    <text-decorator weight="bold">
                        Totale statistieken voor
                    </text-decorator>
                    <text-decorator :color="'primary'">
                        <input-group v-model="selectedRange">
                            <template #input>
                                <select-input
                                    variant="inline"
                                    :items="availableRanges"
                                    value-key-name="value"
                                    label-key-name="label"
                                />
                            </template>
                        </input-group>
                    </text-decorator>
                </flex-container>
            </text-heading>

            <create-flow-from-template-button />
        </flex-container>

        <statistics-tray
            :range="selectedRange"
        />

        <div style="margin-top: 3rem; margin-bottom: 1rem">
            <text-heading>
                Dit volg jij nu op
            </text-heading>
        </div>

        <div class="flows-list">
            <flow-card
                v-for="flow in flows.data.value"
                :key="flow.id.value"
                :flow="flow"
                :range="selectedRange"
                @change="flows.load"
            />

            <upgrade-to-key-vue-card />
        </div>
    </div>

    <template v-else>
        <flow-collection-empty-message />
    </template>

    <router-view />
</template>

<script setup lang="ts">
    import { TextHeading, SelectInput } from '@keyvue/one-ui';
    import { Flow, Range } from '@keyvue/one-api-client';
    import { computed, type Ref, ref } from 'vue';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import useEventBus from '@/services/eventbus/composables/useEventBus';
    import FlowDeletedEvent from '@/flow/flow/events/FlowDeletedEvent';

    import FlowCollectionEmptyMessage from '@/flow/flow/components/FlowCollectionEmptyMessage.vue';
    import FlowCard from '@/flow/flow/components/FlowCard.vue';
    import UpgradeToKeyVueCard from '@/flow/flow/components/UpgradeToKeyVueCard.vue';
    import StatisticsTray from '@/flow/statistics/components/StatisticsTray.vue';
    import CreateFlowFromTemplateButton from '@/flow/template/components/CreateFlowFromTemplateButton.vue';

    const { getResourceCollection } = useClient();
    const eventBus = useEventBus();

    const flows = await getResourceCollection(Flow, { 'order[name]': 'asc' });

    const selectedRange = ref(Range.THIS_WEEK) as Ref<Range>;
    const availableRanges = computed(() => Range.values);

    eventBus.subscribe(FlowDeletedEvent, flows.load);
</script>

<style scoped lang="scss">
.text-heading {
    font-weight: 900;
    margin-bottom: size(sm);

    * {
        font-size: inherit;
    }
}

.flows-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: size(md);
    align-items: flex-start;
}

.upgrade-now {
    border: dashed 3px color(brand-pink) !important;
    padding: size(md) size(xl);
}
</style>
